import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../../auth';
import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../../../api';
import Select from 'react-select';

function ModalTambahPcpSewaDetailDatabase({
    showAddPcpSewaDetail,
    setShowAddPcpSewaDetail,
    formStyles,
    pcpData,
    accessToken,
    retrievePCPDetail
}) {

    const { userInfo } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [listCategory, setListCategory] = useState([]);

    const retrieveCategoryProduct = () => {

        axiosAuth.get(`/api/pcp/categories`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,

                },

            })
            .then(res => {

                setListCategory(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveCategoryProduct();
    }, [accessToken]);

    const [productName, setProductName] = useState('');
    const [duration, setDuration] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [productDesc, setProductDesc] = useState('');
    const [buyingPrice, setBuyingPrice] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [qty, setQty] = useState('');

    const categoryOptions = listCategory.map(category => ({
        value: category.id,
        label: category.categoryName,
    }));

    const handleSelectedCategory = selectedOption => {
        setSelectedCategory(selectedOption);
    };

    const overHead = parseFloat(sellingPrice) * parseFloat(duration) * parseFloat(qty) * 0.03 || 0;

    const [edlCost, setEdlCost] = useState(0);
    const [financialCostPercentage, setFinancialCostPercentage] = useState(10);
    const financialCostAmount = buyingPrice * qty * (financialCostPercentage / 100) || 0;
    const [otherFinancialCost, setOtherFinancialCost] = useState(0);
    const [otherAllowance, setOtherAllowance] = useState(0);

    const calculatedSubTotal = parseFloat(sellingPrice) * parseInt(qty, 10) * parseInt(duration, 10);

    const calculatedPurchaseTotal = parseFloat(buyingPrice) * parseInt(qty, 10);

    const grossMargin = parseFloat(calculatedSubTotal) - parseFloat(calculatedPurchaseTotal) || 0;

    const subTotalCost = (overHead || 0) + (edlCost || 0) + (financialCostAmount || 0) + (otherFinancialCost || 0) + (otherAllowance || 0);

    const nettMargin = parseFloat(grossMargin) - parseFloat(subTotalCost) || 0;

    const nettPercentage = parseInt(nettMargin) / parseInt(calculatedSubTotal) * 100 || 0;

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);

    function handleChangeEdl(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setEdlCost(numericValue);
    };

    function handleChangeOtherFinancial(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setOtherFinancialCost(numericValue);
    };

    function handleChangeOtherAllowance(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setOtherAllowance(numericValue);
    };

    function handleChangeBuyingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setBuyingPrice(numericValue);
    };

    function handleChangeSellingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setSellingPrice(numericValue);
    };

    const handleClose = () => {
        setShowAddPcpSewaDetail(false);
        setSelectedCategory(null);
        setProductName('');
        setProductDesc('');
        setDuration('');
        setBuyingPrice('');
        setSellingPrice('');
        setQty('');
        setEdlCost('');
        setOtherFinancialCost('');
        setOtherAllowance('');
    };

    const handleFormSubmit = async (e) => {

        e.preventDefault();

        setIsSubmitting(true);
        setDisabled(true);

        const pcpDetailData = {
            productName: productName || '',
            productDesc: productDesc || '',
            categoryId: selectedCategory?.value,
            duration: parseInt(duration * 30) || 0,
            buyingPrice: buyingPrice || 0,
            sellingPrice: sellingPrice || 0,
            quantity: parseInt(qty) || 0,
            pcpId: pcpData?.id,
            username: userInfo?.username,
            subtotal: calculatedSubTotal,
            overhead: overHead,
            edl: edlCost || 0,
            financialCostPercentage: parseInt(financialCostPercentage),
            financialCost: financialCostAmount,
            otherFinancialCost: otherFinancialCost || 0,
            otherAllowance: otherAllowance || 0,
            nett: nettMargin
        };

        try {

            const response = await axiosAuth.post(`/api/pcp/sewa/details`, pcpDetailData, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan Produk',
                showConfirmButton: true,
            });

            retrievePCPDetail();

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat menambahkan Produk',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }
    };

    const formStyles2 = {
        inputNettmargin: {
            color: nettMargin <= 300000
                ? 'red'
                : theme === 'light'
                    ? '#FFFFFF'
                    : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputBodyGroup: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            maxHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            width: '100%', // make sure it stretches
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    return (
        <Modal
            show={showAddPcpSewaDetail}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size='xl'
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', }}>
                    Tambah PCP Produk
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit} >
                    <Row>
                        <Col xs={12} lg={5}>
                            <Row>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={formStyles.label} htmlFor='productName'>Nama Produk*</Form.Label>
                                        <Form.Control
                                            id='productName'
                                            type='text'
                                            onChange={(e) => setProductName(e.target.value)}
                                            value={productName}
                                            required
                                            placeholder='Nama Produk'
                                            style={formStyles.input}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={formStyles.label} htmlFor='duration'>Durasi Sewa (Bulan)*</Form.Label>
                                        <Form.Control
                                            id='duration'
                                            type='text'
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setDuration(value);
                                                }
                                            }}
                                            value={duration}
                                            required
                                            placeholder='Durasi Sewa'
                                            style={formStyles.input}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={formStyles.label} htmlFor='category'>Jenis Produk*</Form.Label>
                                        <Select
                                            id='category'
                                            options={categoryOptions}
                                            required
                                            value={selectedCategory}
                                            onChange={handleSelectedCategory}
                                            styles={selectStyles}
                                            placeholder='Pilih Jenis Produk'
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={formStyles.label} htmlFor='spec'>Spesifikasi</Form.Label>
                                        <Form.Control
                                            id='spec'
                                            as='textarea'
                                            rows={4}
                                            onChange={(e) => setProductDesc(e.target.value)}
                                            value={productDesc}
                                            style={formStyles.input}
                                            placeholder='Spesifikasi'
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={formStyles.label} htmlFor='buyingPrice'>Harga Beli*</Form.Label>
                                        <Form.Control
                                            id='buyingPrice'
                                            type='text'
                                            onChange={handleChangeBuyingPrice}
                                            value={`Rp ${buyingPrice ? buyingPrice.toLocaleString('id-ID') : ''}`}
                                            required
                                            placeholder='Harga Beli'
                                            style={formStyles.input}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={formStyles.label} htmlFor='sellingPrice'>Harga Sewa Perbulan*</Form.Label>
                                        <Form.Control
                                            id='sellingPrice'
                                            type='text'
                                            onChange={handleChangeSellingPrice}
                                            value={`Rp ${sellingPrice ? sellingPrice.toLocaleString('id-ID') : ''}`}
                                            required
                                            placeholder='Harga Sewa Perbulan'
                                            style={formStyles.input}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={formStyles.label} htmlFor='qty'>Qty*</Form.Label>
                                        <Form.Control
                                            id='qty'
                                            type='text'
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setQty(value);
                                                }
                                            }}
                                            value={qty}
                                            required
                                            style={formStyles.input}
                                            placeholder='Jumlah'
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={1}></Col>
                        <Col xs={12} lg={6}>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='overHead'>Over Head (3%)</Form.Label>
                                    <Form.Control
                                        id='overHead'
                                        type='text'
                                        className='mb-3'
                                        value={numberFormat(overHead) || 0}
                                        readOnly
                                        style={formStyles.input}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='edlCost'>External Direct Labor Cost</Form.Label>
                                    <Form.Control
                                        id='edlCost'
                                        type='text'
                                        className='mb-3'
                                        onChange={handleChangeEdl}
                                        value={`Rp ${edlCost ? edlCost.toLocaleString('id-ID') : '0,00'}`}
                                        required
                                        style={formStyles.input}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='fcPercentage'>Financial Cost %</Form.Label>
                                    <Form.Control
                                        id='fcPercentage'
                                        type='text'
                                        className='mb-3'
                                        value={financialCostPercentage}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                                setFinancialCostPercentage(value);
                                            }
                                        }}
                                        required
                                        style={formStyles.input}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='financeCost'>Financial Cost Amount</Form.Label>
                                    <Form.Control
                                        id='financeCost'
                                        type='text'
                                        className='mb-3'
                                        value={numberFormat(financialCostAmount)}
                                        readOnly
                                        style={formStyles.input}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='otherFinanceCost'>Other Financial Cost</Form.Label>
                                    <Form.Control
                                        id='otherFinanceCost'
                                        type='text'
                                        className='mb-3'
                                        onChange={handleChangeOtherFinancial}
                                        value={`Rp ${otherFinancialCost ? otherFinancialCost.toLocaleString('id-ID') : '0,00'}`}
                                        required
                                        style={formStyles.input}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='otherAllow'>Other Allowance</Form.Label>
                                    <Form.Control
                                        id='otherAllow'
                                        type='text'
                                        className='mb-3'
                                        onChange={handleChangeOtherAllowance}
                                        value={`Rp ${otherAllowance ? otherAllowance.toLocaleString('id-ID') : '0,00'}`}
                                        required
                                        style={formStyles.input}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='subTotalCost'>Sub Total Cost</Form.Label>
                                    <Form.Control
                                        id='subTotalCost'
                                        type='text'
                                        className='mb-3'
                                        value={numberFormat(subTotalCost) || 0}
                                        readOnly
                                        style={formStyles.input}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Label style={formStyles.label} htmlFor='nettMargin'>Nett Margin</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            id='nettMargin'
                                            type='text'
                                            className='mb-3'
                                            value={numberFormat(nettMargin) || '0,00'}
                                            readOnly
                                            style={formStyles2.inputNettmargin}
                                        />
                                        <InputGroup.Text
                                            id="basic-addon1"
                                            style={formStyles2.inputBodyGroup}
                                        >
                                            {nettPercentage.toFixed(2) + '%'}
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <div className="d-grid gap-2 mt-4 mb-2">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={
                                    disabled ||
                                    !productName ||
                                    !duration ||
                                    !sellingPrice ||
                                    !qty
                                }
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalTambahPcpSewaDetailDatabase
